import { render, staticRenderFns } from "./StockMateriaPrimerBalaDetail.vue?vue&type=template&id=60eb6696&scoped=true"
import script from "./StockMateriaPrimerBalaDetail.vue?vue&type=script&lang=js"
export * from "./StockMateriaPrimerBalaDetail.vue?vue&type=script&lang=js"
import style0 from "./StockMateriaPrimerBalaDetail.vue?vue&type=style&index=0&id=60eb6696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb6696",
  null
  
)

export default component.exports